module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1030-68fa3b719eb1affba889fac29103a41d.png";